import { NotePage } from '../NotePage/NotePage';
import { HormoneReplacementParagraphs } from './Paragraphs';

export const HormoneReplacement = () => (
  <NotePage
    title="Hormonal balance through different life stages"
    eyebrow="Wellness note"
    summary="A readable overview of how hormonal shifts can influence energy, sleep, mood, body composition, and long-term wellbeing."
    paragraphs={HormoneReplacementParagraphs}
    relatedTitle="Hormone Replacement"
    appointmentServiceValue="Hormone Replacement"
  />
);
